import React, { useEffect, useState } from 'react'
import * as Title from '../../constants/PageTitle'
import { HttpService, API, DateFormat, toTitleCase } from '../../config/react'
import { S3_BUCKET_URL } from '../../config/HttpService'
const Dashboard = () => {
  const [DashboardCounts, setDashboardCounts] = useState([])
  const [BestSellerProduct, setBestSellerProduct] = useState([])
  const [lastOrderProducts, setlastOrderProduct] = useState([])
  const [TopSearchTerm, setTopSearchTerm] = useState([])
  const [LastSearchTerm, setLastSearchTerm] = useState([])
  const [MostViewedProducts, setMostViewedProducts] = useState([])
  useEffect(() => {
    document.title = Title.Dashboard
    GetKeywordList()
    GetLastSearchKeywordList()
    GetCounts()
    GetBestSellingProduct()
    GetlastOrderProduct()
    GetMostViewProducts()
  }, [])
  const GetCounts = () => {
    HttpService.getApi(API.DashboardCounts, null).then((response) => {
      setDashboardCounts(response.data.result[0][0])
    })
  }
  const GetBestSellingProduct = () => {
    HttpService.getApi(API.BestSellerProduct, null).then((response) => {
      setBestSellerProduct(response.data.result)
    })
  }
  const GetMostViewProducts = () => {
    HttpService.getApi(API.GetMostViewProducts, null).then((response) => {
      setMostViewedProducts(response.data.result)
    })
  }
  const GetlastOrderProduct = () => {
    HttpService.getApi(API.lastorderProducts, null).then((response) => {
      setlastOrderProduct(response.data.result)
    })
  }
  const GetKeywordList = () => {
    const param = {
      page: 1,
      search: '',
      page_size: 5,
      sort_column: '',
      sort_direction: ''
    }
    HttpService.postApi(API.GetSearchTerms, param).then((response) => {
      if (response.data.status === true && response.data.result !== '') {
        const data = response.data.result[1]
        setTopSearchTerm(data)
      } else {
        setTopSearchTerm([])
      }
    })
  }
  const GetLastSearchKeywordList = () => {
    HttpService.getApi(API.GetLastSearchTerms).then((response) => {
      if (response.data.status === true && response.data.result !== '') {
        const data = response.data.result[0]
        setLastSearchTerm(data)
      } else {
        setLastSearchTerm([])
      }
    })
  }
  return (
    <div className="content-wrapper pb-0">
      {/* <div className="alert alert-warning alert-dismissible fade show" role="alert">
                You should check in on some of those fields below. <strong>Holy guacamole!</strong>
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div className="alert alert-success alert-dismissible fade show" role="alert">
                You should check in on some of those fields below. <strong>Holy guacamole!</strong>
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                You should check in on some of those fields below. <strong>Holy guacamole!</strong>
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div> */}

      <div className="row-cols-1 row-cols-md-2 row-cols-lg-4 row-cols-xl-4 mx-0 mb-4 card flex-initial">
        <div className="col my-3 border-right">
          <div className="">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="card-title py-2 mb-0 font-weight-bold">
                  <img
                    width="50px"
                    className="mr-2"
                    src={S3_BUCKET_URL + 'assets/images/Orders-icon.svg'}
                    alt=" "
                  />
                  Online Orders
                </div>
                <div className="d-none text-muted font-20">
                  <select className="form-control select-custom outline-0">
                    <option>Monthly</option>
                    <option>Yearly</option>
                  </select>
                </div>
              </div>
              <h2 className="font-weight-bold pl-5 ml-2 d-flex align-items-center">
                {DashboardCounts.total_orders}
                {/* <span className="border-curcle badge-pill badge badge-success ml-2">4,5%<i className="mdi mdi-arrow-up"></i></span> */}
              </h2>
            </div>
          </div>
        </div>
        <div className="col my-3">
          <div className="">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="card-title py-2 mb-0 font-weight-bold">
                  <img
                    width="50px"
                    className="mr-2"
                    src={S3_BUCKET_URL + 'assets/images/Diamondicon.svg'}
                    alt=" "
                  />
                  Total Diamonds
                </div>
                <div className="d-none text-muted font-20">
                  <select className="form-control select-custom outline-0">
                    <option>This Monthly</option>
                    <option>Yearly</option>
                  </select>
                </div>
              </div>
              <div className="total-diamond-part pl-5 ml-2">
                <h2 className=" font-weight-bold d-flex align-items-end">
                  {DashboardCounts.total_earth_mined_diamonds}
                  <span className="text-gray font-13 py-0 ml-2 mb-1 font-weight-normal">
                    Natural Diamonds
                  </span>
                </h2>
              </div>
              <div className="total-diamond-part pt-1 pl-5 ml-2">
                <h2 className=" font-weight-bold d-flex align-items-end mb-0">
                  {DashboardCounts.total_lab_grown_diamonds}
                  <span className="text-gray font-13 py-0 ml-2 mb-1 font-weight-normal">
                    Lab Diamonds
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="col my-3 border-left">
          <div className="">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="card-title py-2 mb-0 font-weight-bold">
                  <img
                    width="50px"
                    className="mr-2"
                    src={S3_BUCKET_URL + 'assets/images/Purchase-icon.svg'}
                    alt=" "
                  />
                  Total Products
                </div>
              </div>
              <h2 className="font-weight-bold pl-5 ml-2 d-flex align-items-center">
                {DashboardCounts.total_products}
                {/* <span className="border-curcle badge-pill badge badge-success ml-2">4,5%<i className="mdi mdi-arrow-up"></i></span> */}
              </h2>
            </div>
          </div>
        </div>
        <div className="col my-3 border-left">
          <div className="">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="card-title py-2 mb-0 font-weight-bold">
                  <img
                    width="50px"
                    className="mr-2"
                    src={S3_BUCKET_URL + 'assets/images/Customers-icon.svg'}
                    alt=" "
                  />
                  Customers
                </div>
              </div>
              <h2 className="font-weight-bold pl-5 ml-2 d-flex align-items-center">
                {DashboardCounts.total_customers}
                {/* <span className="border-curcle badge-pill badge badge-success ml-2">4,5%<i className="mdi mdi-arrow-up"></i></span> */}
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 col-xl-6">
          <div className="card p-3 grid-margin">
            <div className="d-flex border-bottom align-items-center justify-content-between">
              <div className="card-title py-2 mb-2 font-weight-bold card-border">Best Sellers</div>
            </div>
            <div
              className="tab-content"
              id="myTabContent"
            >
              <div
                className="tab-pane fade show active"
                id="bestseller"
                role="tabpanel"
                aria-labelledby="bestseller-tab"
              >
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th width="15%">Image</th>
                        <th>Name</th>
                        <th>SKU</th>
                        <th width="15%">Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {console.log(BestSellerProduct)} */}
                      {BestSellerProduct.map((item, index) => (
                        <tr key={Math.random()}>
                          <td>
                            <img
                              src={item.base_image}
                              className="mr-2 product-img"
                              alt="image"
                            />
                          </td>
                          <td className="text-left">
                            <span>{item.name}</span>
                          </td>
                          <td>{item.sku}</td>
                          <td>{item.Quantity}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 col-xl-6">
          <div className="card p-3 grid-margin">
            <div className="d-flex border-bottom align-items-center justify-content-between">
              <div className="card-title py-2 mb-2 font-weight-bold card-border">
                Most Viewed Products
              </div>
            </div>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th width="15%">Image</th>
                    <th>Name</th>
                    <th>SKU</th>
                    <th width="15%">Count</th>
                  </tr>
                </thead>
                <tbody>
                  {MostViewedProducts.map((item, index) => (
                    <tr key={Math.random()}>
                      <td>
                        <img
                          src={item.base_image}
                          className="mr-2 product-img"
                          alt="image"
                        />
                      </td>
                      <td className="text-left">
                        <span>{toTitleCase(item.name)}</span>
                      </td>
                      <td>{item.sku}</td>
                      <td>{item.clicks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* table row starts here  */}
      <div className="row pb-3">
        <div className="col-xl-12">
          <div className="card p-3 grid-margin">
            <ul
              className="nav nav-tabs mb-4"
              id="myTab"
              role="tablist"
            >
              <li className="nav-item">
                <a
                  className="nav-link active"
                  id="lastorders-tab"
                  data-toggle="tab"
                  href="#lastorders"
                  role="tab"
                  aria-controls="lastorders"
                  aria-selected="true"
                >
                  Last Orders
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="lastsearchterm-tab"
                  data-toggle="tab"
                  href="#lastsearchterm"
                  role="tab"
                  aria-controls="lastsearchterm"
                  aria-selected="false"
                >
                  Last Search Terms
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="topsearchterm-tab"
                  data-toggle="tab"
                  href="#topsearchterm"
                  role="tab"
                  aria-controls="topsearchterm"
                  aria-selected="false"
                >
                  Top Search Terms
                </a>
              </li>
            </ul>
            <div
              className="tab-content"
              id="myTabContent"
            >
              <div
                className="tab-pane fade show active"
                id="lastorders"
                role="tabpanel"
                aria-labelledby="lastorders-tab"
              >
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th width="15%">Image</th>
                        <th>Item</th>
                        <th>Customer</th>
                        <th width="15%">Total</th>
                        <th>Order date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lastOrderProducts.map((item, index) => (
                        <tr key={Math.random()}>
                          <td>
                            <img
                              src={item.base_image}
                              className="mr-2 product-img"
                              alt="image"
                            />
                          </td>
                          <td className="text-left">
                            <span>{item.name}</span>
                          </td>
                          <td>{item.customer_name}</td>
                          <td>{'£' + item.price}</td>
                          <td>
                            {' '}
                            <DateFormat value={item.created_at}></DateFormat>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="lastsearchterm"
                role="tabpanel"
                aria-labelledby="lastsearchterm-tab"
              >
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="w-25">Keyword</th>
                        <th className="w-25">Number of Uses</th>
                        <th className="w-25">Number of Result</th>
                        <th className="w-25">Last Search Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {LastSearchTerm.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <span>{item.keyword}</span>
                          </td>
                          <td>
                            <span>{item.no_of_users}</span>
                          </td>
                          <td>{item.no_of_result}</td>
                          <td>
                            {' '}
                            <DateFormat value={item.date}></DateFormat>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="topsearchterm"
                role="tabpanel"
                aria-labelledby="topsearchterm-tab"
              >
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="w-25">Keyword</th>
                        <th className="w-25">Number of Uses</th>
                        <th className="w-25">Number of Result</th>
                        <th className="w-25">Last Search Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {TopSearchTerm !== undefined &&
                        TopSearchTerm.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <span>{item.keyword}</span>
                            </td>
                            <td>
                              <span>{item.no_of_users}</span>
                            </td>
                            <td>{item.no_of_result}</td>
                            <td>
                              {' '}
                              <DateFormat value={item.updated_at}></DateFormat>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-xl-1 grid-margin">
          <div className="card grid-margin">
            <div className="card-header d-flex justify-content-between align-items-center">
                            <div className="card-title py-2 mb-2 font-weight-bold card-border">Activity
                            </div>
                        </div>
            <div className="card-body">
              <select className="form-control select-custom ml-auto outline-0 mb-2">
                                <option>Today</option>
                            </select>
                            <div className="d-flex border-bottom py-3">
                                <div className="pl-0">
                                    <p className="mb-1 text-black font-14"> Jennifer Scott changed product status from active to draft : <strong>Frill Stud Earrings</strong></p>
                                    <span className="font-12 text-gray">October 6, 2021. 2:15 PM</span>
                                </div>
                            </div>
                            <div className="d-flex border-bottom py-3">
                                <div className="pl-0">
                                    <p className="mb-1 text-black font-14"> Jennifer Scott changed product status from active to draft : <strong>Frill Stud Earrings</strong></p>
                                    <span className="font-12 text-gray">October 6, 2021. 2:15 PM</span>
                                </div>
                            </div>
                            <div className="d-flex border-bottom py-3">
                                <div className="pl-0">
                                    <p className="mb-1 text-black font-14"> Jennifer Scott changed product status from active to draft : <strong>Frill Stud Earrings</strong></p>
                                    <span className="font-12 text-gray">October 6, 2021. 2:15 PM</span>
                                </div>
                            </div>
                            <div className="d-flex pt-3">
                                <div className="pl-0">
                                    <p className="mb-1 text-black font-14"> Jennifer Scott changed product status from active to draft : <strong>Frill Stud Earrings</strong></p>
                                    <span className="font-12 text-gray">October 6, 2021. 2:15 PM</span>
                                </div>
                            </div>

                            <div className="pt-3 text-center">
                                <p className="mb-5 text-black font-12"><a href="#" className="text-gray"><u>View all recent activity</u></a></p>
                            </div>
                            <hr />
              <div className="pt-4">
                <div className="card-title py-2 mb-2 font-weight-bold card-border">Activity</div>
              </div>
              <div className="pt-4">
                <div className="row">
                  <div className="col-md-6">
                    <a
                      href="#"
                      className="d-flex font-12 text-gray align-items-center mb-3"
                    >
                      <img
                        src="./assests/images/message-square.svg"
                        alt="Comments"
                        className="mr-2"
                      />
                      <span>1 Comments</span>
                    </a>
                  </div>
                  <div className="col-md-6">
                    <a
                      href="#"
                      className="d-flex font-12 text-gray align-items-center mb-3"
                    >
                      <img
                        src="./assests/images/post.svg"
                        alt="Posts"
                        className="mr-2"
                      />
                      <span>13 Posts</span>
                    </a>
                  </div>
                  <div className="col-md-6">
                    <a
                      href="#"
                      className="d-flex font-12 text-gray align-items-center mb-3"
                    >
                      <img
                        src="./assests/images/file-text.svg"
                        alt="Pages"
                        className="mr-2"
                      />
                      <span>7 Pages</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default Dashboard
